import React from 'react'
import _ from 'lodash'

export default function DisplayInputTextAttribute({
  stationData,
  attributeData,
}) {
  return <div className="text-sm">{attributeData.inputText}</div>
}
